/**
* functions common timeout
*
* @category   Javascript
* @author     Jakob Ohlsen <jakob.ohlsen@gmail.com>
* @copyright  2025 Jakob Ohlsen
*/
export function delayedFunction(timeouts, fn) {
    // Clone defensively so the caller's array is not mutated by the internal
    // `.pop()`-driven recursion. Without this, callers who pass a long-lived
    // "default delays" array end up with it empty after the chain.
    delayedFunctionInternal([...timeouts], fn);
}
function delayedFunctionInternal(timeouts, fn) {
    const timeout = timeouts.pop();
    if (timeout !== undefined) {
        setTimeout(() => {
            fn(timeout);
            delayedFunctionInternal(timeouts, fn);
        }, timeout);
    }
}
